<template>
  <el-dialog :close-on-click-modal="false"
             v-bind="$attrs"
             v-on="$listeners"
             :title="title"
             @closed="closed"
             width="700px">
    <div style="margin: 0 30px 0 30px" :key="pattern">
      <el-form label-position="right" label-width="100px">
        <div style="display: flex">
          <div style="flex-grow: 1">
            <el-form-item label="工单号">
              <label class="value">{{work.extraId || work.id}}</label>
            </el-form-item>
            <el-form-item label="车牌号">
              <label class="value">{{work.carNo | carNo}}</label>
            </el-form-item>
          </div>
          <div style="flex-grow: 1">
            <el-form-item label-width="100px" label="预计完成时间">
              <label class="value">{{work.enterTime}}</label>
            </el-form-item>
            <el-form-item label="车辆型号">
              <label class="value">{{work.brandName}} / {{work.model}}</label>
            </el-form-item>
          </div>
        </div>
      </el-form>

      <el-form label-position="right" label-width="100px" :model="request" :rules="rules" ref="request">
        <el-form-item v-if="isInterrupt" label="原因" prop="reasonId">
          <remote-select class-name="INTERRUPT_REASON" v-model="request.reasonId"></remote-select>
        </el-form-item>
        <el-form-item v-else label="机修技师" prop="technicianId">
          <remote-select class-name="MachineTechnician" v-model="request.technicianId"></remote-select>
        </el-form-item>
        <el-form-item label="备注">
          <el-input type="textarea" v-model="request.remarks" :rows="4" maxlength="200" resize="none"></el-input>
        </el-form-item>
      </el-form>
    </div>

    <template #footer>
      <el-button type="primary" @click="confirm">确 定</el-button>
      <el-button @click="cancel">取 消</el-button>
    </template>
  </el-dialog>
</template>

<script>
  import RemoteSelect from '@/components/selector/RemoteSelect'
  import { interruptWork } from '@/utils/request'
  import authority from '@/utils/authority'
  import workStatus from '@/utils/workStatus'

  export default {
    name: 'InterruptWorkDialog',
    components: { RemoteSelect },
    props: {
      pattern: {
        type: String, // INTERRUPT, MACHINE_REPAIR
        required: true
      },
      work: {
        type: Object,
        required: true
      }
    },
    data () {
      return {
        request: {
          workId: null,
          workStatus: null,
          reasonId: null,
          technicianId: null,
          remarks: null
        },
        rules: {
          reasonId: [
            {
              required: true,
              message: '请选择中断原因',
              trigger: 'change'
            }
          ],
          technicianId: [
            {
              required: true,
              message: '请选择机修技师',
              trigger: 'change'
            }
          ]
        }
      }
    },
    methods: {
      closed () {
        this.request.workId = null
        this.request.workStatus = null
        this.request.reasonId = null
        this.request.technicianId = null
        this.request.remarks = null
        this.$refs.request.resetFields()
      },
      cancel () {
        this.hide()
      },
      confirm () {
        this.$refs.request.validate(valid => {
          if (!valid) return

          this.request.workId = this.work.id
          this.request.workStatus = this.workStatus
          this.work.loading = true
          interruptWork(this.$_.cloneDeep(this.request))
            .then(() => this.hide())
            .catch(() => {
              this.work.loading = false
            })
        })
      },
      hide () {
        this.$emit('update:visible', false)
      }
    },
    computed: {
      isInterrupt () {
        return this.pattern === authority.INTERRUPT
      },
      workStatus () {
        return this.isInterrupt ? workStatus.INTERRUPT : workStatus.MACHINE_REPAIR_WAIT
      },
      title () {
        return this.isInterrupt ? '中断工单' : '转机修'
      }
    }
  }
</script>

<style scoped>

</style>
